(function () {
  'use strict';

  var previewImg = document.getElementById('fp-split-preview-img');
  var grid       = document.getElementById('fp-split-grid');
  var panel      = document.querySelector('.fp-split__right');

  if (!previewImg || !grid || !panel) return;

  var cache      = {};
  var currentSrc = null;

  function preload(src) {
    if (!src || cache[src]) return;
    var img = new Image();
    img.src = src;
    cache[src] = img;
  }

  function bindHover(item) {
    if (item.dataset.hoverBound) return;
    item.dataset.hoverBound = '1';

    item.addEventListener('mouseenter', function () {
      var src   = item.dataset.imgHover || item.dataset.img;
      var title = item.dataset.title;
      var price = item.dataset.price;

      document.querySelectorAll('.fp-split__item').forEach(function (i) {
        i.classList.remove('is-active');
      });
      item.classList.add('is-active');

      if (!src || src === currentSrc) return;
      currentSrc = src;

      if (cache[src] && cache[src].complete) {
        previewImg.src = src;
        previewImg.style.opacity = '1';
      } else {
        previewImg.style.opacity = '0';
        setTimeout(function () {
          previewImg.src = src;
          previewImg.onload = function () { previewImg.style.opacity = '1'; };
        }, 80);
      }
    });
  }

  function bindSwatches(item) {
    var swatches = item.querySelectorAll('.fp-split__swatch');
    if (!swatches.length) return;

    var cardImg = item.querySelector('.fp-split__item-media img');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('mouseenter', function () {
        var img   = swatch.dataset.img;
        var thumb = swatch.dataset.thumb;

        /* Thumbnail in der Karte wechseln */
        if (cardImg && thumb) cardImg.src = thumb;

        /* Preview links wechseln */
        if (img && img !== currentSrc) {
          currentSrc = img;
          if (cache[img] && cache[img].complete) {
            previewImg.src = img;
            previewImg.style.opacity = '1';
          } else {
            previewImg.style.opacity = '0';
            setTimeout(function () {
              previewImg.src = img;
              previewImg.onload = function () { previewImg.style.opacity = '1'; };
            }, 80);
          }
        }

        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');
      });
    });
  }

  function initItems(items, preloadAll) {
    Array.prototype.forEach.call(items, function (item, i) {
      bindHover(item);
      bindSwatches(item);
      if (preloadAll || i < 8) {
        preload(item.dataset.img);
        preload(item.dataset.imgHover);
      }
    });
  }

  /* Initial load */
  var initial = grid.querySelectorAll('.fp-split__item');
  initItems(initial, false);

  /* Lazy-preload rest after 1.5s */
  setTimeout(function () {
    Array.prototype.forEach.call(initial, function (item, i) {
      if (i >= 8) {
        preload(item.dataset.img);
        preload(item.dataset.imgHover);
      }
    });
  }, 1500);

  /* ---- Infinite Scroll ---- */
  var trigger = grid.querySelector('.fp-infinite-trigger');
  if (!trigger) return;

  var loading      = false;
  var prefetchedHtml = null;
  var prefetchedUrl  = null;

  /* Nächste Seite im Hintergrund vorladen */
  function prefetch(url) {
    if (!url || prefetchedUrl === url) return;
    prefetchedUrl = url;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) { prefetchedHtml = html; })
      .catch(function () {});
  }

  /* Sofort nach dem Laden die nächste Seite prefetchen */
  setTimeout(function () { prefetch(trigger.dataset.nextUrl); }, 200);

  /* Perf fix 2026-06-10: the old isTriggerNear() proximity check
     (rect.top < panelRect.bottom + 1200 || rect.top < innerHeight + 1200)
     was always true in this split layout, so EVERY page of the collection
     was fetched and appended on initial load (13 fetches, 228 images, 6.5 MB).
     IntersectionObserver respects ancestor clipping (scroll panel), so the
     next page now only loads when the trigger really comes within 1200px. */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !loading && trigger && trigger.parentNode) loadNext();
      });
    }, { root: null, rootMargin: '1200px 0px' });
    io.observe(trigger);
  } else {
    /* legacy fallback: original scroll listeners */
    var checkAndLoad = function () {
      if (loading || !trigger || !trigger.parentNode) return;
      var rect = trigger.getBoundingClientRect();
      if (rect.top < window.innerHeight + 1200) loadNext();
    };
    panel.addEventListener('scroll', checkAndLoad, { passive: true });
    window.addEventListener('scroll', checkAndLoad, { passive: true });
    setTimeout(checkAndLoad, 300);
  }

  function processHtml(html) {
    var doc     = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.getElementById('fp-split-grid');

    if (!newGrid) { stop(); return; }

    var newItems = newGrid.querySelectorAll('.fp-split__item');
    newItems.forEach(function (item) {
      item.querySelectorAll('img').forEach(function (img) {
        img.setAttribute('loading', 'lazy');
      });
      grid.insertBefore(item, trigger);
    });

    /* Perf fix 2026-06-10: was initItems(newItems, true) — preloaded the full-size
       preview + hover image for EVERY appended product. Now same policy as the
       initial page: only the first 8 per batch, the rest load on hover. */
    initItems(newItems, false);

    var newTrigger = doc.querySelector('.fp-infinite-trigger');
    if (newTrigger && newTrigger.dataset.nextUrl) {
      trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
      prefetchedHtml = null;
      prefetchedUrl  = null;
      prefetch(trigger.dataset.nextUrl); /* nächste Seite sofort prefetchen */
    } else {
      stop();
      return;
    }

    loading = false;
    /* re-arm the observer so it re-evaluates the trigger's new position */
    if (io) { io.unobserve(trigger); io.observe(trigger); }
  }

  function loadNext() {
    var nextUrl = trigger.dataset.nextUrl;
    if (!nextUrl) { stop(); return; }

    loading = true;

    /* Wenn prefetched → sofort einfügen, kein Warten */
    if (prefetchedHtml && prefetchedUrl === nextUrl) {
      var html = prefetchedHtml;
      prefetchedHtml = null;
      prefetchedUrl  = null;
      processHtml(html);
    } else {
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(processHtml)
        .catch(function () { stop(); });
    }
  }

  function stop() {
    if (io) { io.disconnect(); io = null; }
    if (typeof checkAndLoad === 'function') {
      panel.removeEventListener('scroll', checkAndLoad);
      window.removeEventListener('scroll', checkAndLoad);
    }
    if (trigger && trigger.parentNode) trigger.remove();
    loading = false;
  }
})();

/* ── Filter Drawer ── */
(function () {
  var openBtn  = document.getElementById('fp-filter-open');
  var closeBtn = document.getElementById('fp-filter-close');
  var drawer   = document.getElementById('fp-filter-drawer');
  var backdrop = document.getElementById('fp-filter-backdrop');

  if (!openBtn || !drawer) return;

  /* Teleport drawer + backdrop to <body> to escape any stacking context */
  document.body.appendChild(backdrop);
  document.body.appendChild(drawer);

  var OPEN_TRANSITION  = 'transform 0.52s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.32s cubic-bezier(0.22, 1, 0.36, 1)';
  var CLOSE_TRANSITION = 'transform 0.32s cubic-bezier(0.4, 0, 0.6, 1), opacity 0.26s cubic-bezier(0.4, 0, 0.6, 1)';

  function openDrawer() {
    drawer.style.transition = 'none';
    backdrop.hidden = false;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.style.transition = OPEN_TRANSITION;
        backdrop.classList.add('is-open');
        drawer.classList.add('is-open');
        drawer.removeAttribute('aria-hidden');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('fp-filter-open');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  function closeDrawer() {
    drawer.style.transition = CLOSE_TRANSITION;
    backdrop.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('fp-filter-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      backdrop.hidden = true;
      drawer.hidden = true;
    }, 350);
  }

  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.querySelectorAll('.fp-filter-pill input[type="checkbox"]').forEach(function (cb) {
    cb.closest('.fp-filter-pill').addEventListener('click', function () {
      cb.checked = !cb.checked;
      this.classList.toggle('is-active', cb.checked);
    });
  });
})();
